import React from 'react';
import { createBrowserRouter } from 'react-router';
import App from '../app.container';
import InitialContent from '../initial-content/initial-content.container';
import InitialContentRoutes from '../initial-content/initial-content-routes/initial-content-routes.component';
import { ROUTE_CONTENT_ALL } from '../../../constants/system/routes';

const Router: ReactRouter = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        element: <InitialContent />,
        children: [
          {
            path: ROUTE_CONTENT_ALL,
            element: <InitialContentRoutes />,
          },
        ],
      },
    ],
  },
]);

export default Router;
